import { gql } from 'graphql-tag';
export const getOecResponseSummary = gql`
  query trainingCounts($surveyId: ID!, $questionId: ID!, $isSolutions: Boolean) {
    getOecResponseSummary(surveyId: $surveyId, questionId: $questionId, isSolutions: $isSolutions) {
      counts {
        responseCount
        themesCount
        autoTaggedCount
        manualTaggedCount
        untaggedCount
      }
    }
  }
`;